export default function handleMeetTheTeamLoad() {
	const ourTeamSection = document.querySelector('.our-team-section') as HTMLElement;
	setTimeout(() => {
		ourTeamSection.style.removeProperty('height');
		ourTeamSection.style.contentVisibility = 'visible';
		ourTeamSection.style.height = 'auto';
	}, 600);
}	